import { EpssProbability } from "@protos/sca/v1/sca";

export const EPSS_FILTER_OPTIONS = [
  {
    label: "High",
    value: EpssProbability.HIGH,
  },
  {
    label: "Medium",
    value: EpssProbability.MEDIUM,
  },
  {
    label: "Low",
    value: EpssProbability.LOW,
  },
  {
    label: "None",
    value: EpssProbability.NONE,
  },
];
